import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { ItemField } from '~/core/services/item-fields/item-fields';
import { MenuTopBarItemComponent } from '~/components/menu-top-bar-item/menu-top-bar-item.component';

@Component({
  selector: 'app-header-dropdown-menu',
  templateUrl: './header-dropdown-menu.component.html',
  styleUrls: ['./header-dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuTopBarItemComponent],
  host: {
    '[class.header-dropdown-menu--before]': "xPosition === 'before'",
  },
})
export class HeaderDropdownMenuComponent {
  @Input() items: ItemField[] = [];
  @Input() xPosition: 'before' | 'after' = 'after';
  @Input() activeItemIds: ReadonlySet<string> = new Set();
  @Input() routerPaths: ReadonlyMap<string, string | null> = new Map();
  @Input() isCasinoOpened: boolean = false;
  @Input() isLightTheme: boolean = false;
  @Input() isLoggedIn: boolean = false;
  @Input() hideButtonLightMode: boolean = false;
  @Input() labelClass: string = 'menu-top-bar__option-label';
  @Input() showCrmButton: boolean = false;
  @Input() inSubheader: boolean = false;

  @Output() readonly itemClick = new EventEmitter<ItemField>();
  @Output() readonly themeToggle = new EventEmitter<void>();
}
